<template>
  <div class="transportDeliveryOrder">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @companyChange="companyChange"
      @receiveCompanyChange="receiveCompanyChange"
      @bankAccountChange="bankAccountChange"
      @salesOrderChange="salesOrderChange"
      @purchaseOrderChange="purchaseOrderChange"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog title="选择入账日期" center :visible.sync="dialogVisible" width="20%">
      <el-date-picker
        v-model="postDate"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        placeholder="选择日期"
      ></el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="selectDate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/financeCenter/payment';
  import tableMixins from '@/common/mixins/table.js';
  import DataBaseAPI from '@/api/dataBase';
  import { filterEmpty } from '@/common/js/util';
  // import MASTER_API from '@/api/masterData/company.js';
  import qs from 'qs';
  import XEUtils from 'xe-utils';
  export default {
    name: 'paymentList',
    mixins: [tableMixins],
    data() {
      return {
        footerTotalCols: { amount: ['paymentAmount', 'paymentAccountedAmount'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        exportAction: API.EXPORT_FUNDPAYMENT,
        query: {
          paymentCompanyCode: null, // 公司
          paymentApplyDepartmentNos: null, // 部门
          receiveCompanyNos: [], // 收款单位
          startPaymentDate: null, // 付款日期从
          endPaymentDate: null, // 付款日期到
          paymentType: null, // 付款类别
          paymentMethod: null, // 付款方式
          paymentApplyNumberLike: null, // 付款申请单号
          startPaymentAmount: null, // 付款金额从
          endPaymentAmount: null, // 付款金额到
          currencyCode: null, // 币种
          bankAccountNum: null, // 付款银行账号
          bankAccountName: null, // 付款银行账户名称
          paymentStatus: null, // 单据状态
          startPaymentCreateDate: null, // 创建日期从
          endPaymentCreateDate: null, // 创建日期到
          salesOrderNo: null, // 销售合同号
          paymentNumLike: null, // 付款单号
          accountingStatus: null, // 入账状态
          paymentCreatePersonName: null, // 创建人
          purchaseOrderNo: null, // 采购合同号
          supplyChainNo: null, //供应链
          contractNo: null, //业务订单号
          billCode: null, //票据号
          creditCode: null, //信用证号
          voucherNo: null,
        },
        companyList: [], // 公司列表
        departmentList: [], // 部门列表
        dialogVisible: false,
        postDate: null,
        //表格显示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'paymentCompanyName',
            title: 'paymentList.table.paymentCompanyCode',
            visible: true,
            width: 180,
            fixed: 'left',
          },
          {
            field: 'paymentNum',
            title: 'paymentList.table.paymentNum',
            visible: true,
            width: 120,
            fixed: 'left',
          },
          {
            field: 'paymentType',
            title: 'paymentList.table.paymentType',
            visible: true,
            width: 120,
            dictType: 'payment_type',
          },
          {
            field: 'paymentMethod',
            title: 'paymentList.table.paymentMethod',
            visible: true,
            width: 120,
            dictType: 'payment_method',
          },
          {
            field: 'paymentDate',
            title: 'paymentList.table.paymentDate',
            visible: true,
            width: 120,
          },
          {
            field: 'receiveCompanyName',
            title: 'paymentList.table.receiveCompanyNo',
            visible: true,
            width: 120,
          },
          {
            field: 'bankName',
            title: 'paymentList.table.bankName',
            visible: true,
            width: 120,
          },
          {
            field: 'bankAccountName',
            title: 'paymentList.table.bankAccountName',
            visible: true,
            width: 120,
          },
          {
            field: 'bankAccountNum',
            title: 'paymentList.table.bankAccountNum',
            visible: true,
            width: 120,
          },
          {
            field: 'paymentAmount',
            title: 'paymentList.table.paymentAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'currencyName',
            title: 'paymentList.table.currencyCode',
            visible: true,
            width: 120,
          },
          {
            field: 'paymentAccountedAmount',
            title: 'paymentList.table.paymentAccountedAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'requestPersonName',
            title: 'paymentList.table.requestPersonName',
            visible: true,
            width: 120,
          },
          {
            field: 'cashAccName',
            title: 'paymentList.table.cashAccName',
            visible: true,
            width: 120,
          },
          {
            field: 'cashFlowItemCode',
            title: 'paymentList.table.cashFlowItemCode',
            visible: true,
            width: 120,
          },
          {
            field: 'paymentStatus',
            title: 'paymentList.table.paymentStatus',
            visible: true,
            width: 120,
            dictType: 'payment_status',
            fixed: 'right',
          },
          {
            field: 'accountingStatus',
            title: 'paymentList.table.accountingStatus',
            visible: true,
            width: 120,
            dictType: 'post_status',
            fixed: 'right',
          },
          {
            field: 'voucherNo',
            title: '凭证号',
            visible: true,
          },
        ],
      };
    },
    computed: {
      searchColumns() {
        return [
          {
            // 公司
            name: this.$t('paymentList.table.paymentCompanyCode'),
            prop: 'paymentCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            clearable: true,
            filterable: true,
          },
          {
            // 部门
            name: this.$t('paymentList.table.paymentApplyDepartmentNo'),
            prop: 'paymentApplyDepartmentNos',
            span: 12,
            type: 'select',
            options: this.departmentList,
            multiple: true,
            filterable: true,
          },
          {
            // 收款单位
            prop: 'receiveCompanyNos',
            name: this.$t('paymentList.table.receiveCompanyNo'),
            type: 'searchTableSpec',
            searchType: 'partner',
            extraData: {
              companyCode: this.query.paymentCompanyCode,
              departmentCode: this.query.paymentApplyDepartmentNo,
              partnerTypes: 'HZHB01,HZHB02,HZHB03',
            },
            changeMethod: 'receiveCompanyChange',
          },
          {
            // 付款日期从
            prop: 'startPaymentDate',
            name: this.$t('paymentList.search.startPaymentDate'),
            type: 'startDaterangePicker',
          },
          {
            // 付款日期到
            prop: 'endPaymentDate',
            name: this.$t('paymentList.search.endPaymentDate'),
            type: 'endDaterangePicker',
          },
          {
            // 付款类别
            type: 'dict',
            prop: 'paymentType',
            name: this.$t('paymentList.table.paymentType'),
            dictType: 'payment_type',
          },
          {
            // 付款方式
            type: 'dict',
            prop: 'paymentMethod',
            name: this.$t('paymentList.table.paymentMethod'),
            dictType: 'payment_method',
          },
          {
            // 付款申请单号
            prop: 'paymentApplyNumberLike',
            name: this.$t('paymentList.table.paymentApplyNumber'),
            type: 'input',
          },
          {
            // 付款金额
            type: 'inputRange',
            prop: ['startPaymentAmount', 'endPaymentAmount'],
            max: 99999999999999.99,
            precision: 2,
            name: this.$t('paymentList.table.paymentAmount'),
          },
          {
            // 币种
            type: 'dict',
            prop: 'currencyCode',
            name: this.$t('paymentList.table.currencyCode'),
            dictType: 'all_currency',
          },
          {
            // 付款银行账户
            prop: 'bankAccountName',
            name: this.$t('paymentList.table.bankAccountNum'),
            type: 'searchTableSpec',
            searchType: 'bankAccount',
            extraData: { companyCode: this.query.paymentCompanyCode },
            isMultiple: true,
            changeMethod: 'bankAccountChange',
          },
          {
            // 单据状态
            type: 'dict',
            prop: 'paymentStatus',
            name: this.$t('paymentList.table.paymentStatus'),
            dictType: 'payment_status',
          },
          {
            // 创建日期从
            prop: 'startPaymentCreateDate',
            name: this.$t('paymentList.search.startPaymentCreateDate'),
            type: 'startDaterangePicker',
          },
          {
            // 创建日期到
            prop: 'endPaymentCreateDate',
            name: this.$t('paymentList.search.endPaymentCreateDate'),
            type: 'endDaterangePicker',
          },
          {
            // 销售合同号
            prop: 'salesOrderNo',
            name: this.$t('paymentList.table.salesOrderNo'),
            type: 'searchTableSpec',
            searchType: 'contract',
            isMultiple: true,
            changeMethod: 'salesOrderChange',
            extraData: {
              contractStatus: 'ZT03',
              contractCategory: 'sales',
            },
          },
          {
            // 付款单号
            prop: 'paymentNumLike',
            name: this.$t('paymentList.table.paymentNum'),
            type: 'input',
          },
          {
            // 入账状态
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('paymentList.table.accountingStatus'),
            dictType: 'post_status',
          },
          {
            // 创建人
            prop: 'paymentCreatePersonName',
            name: this.$t('paymentList.table.paymentCreatePersonName'),
            type: 'input',
          },
          {
            // 采购合同号
            prop: 'purchaseOrderNo',
            name: this.$t('paymentList.table.purchaseOrderNo'),
            type: 'searchTableSpec',
            searchType: 'contract',
            isMultiple: true,
            changeMethod: 'purchaseOrderChange',
            extraData: {
              contractStatus: 'ZT03',
              contractCategory: 'purchase',
            },
          },
          {
            // 供应链
            prop: 'supplyChainNo',
            name: '供应链',
            type: 'searchTableSpec',
            searchType: 'supplychain',
            isMultiple: true,
          },
          {
            // 应付/收票据号
            prop: 'billCode',
            name: '应付/收票据号',
            type: 'input',
          },
          {
            // 信用证号
            prop: 'creditCode',
            name: '信用证号',
            type: 'input',
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.getCompany();
    },
    methods: {
      async getCompany() {
        // 公司

        const selectStatus = await this.$axios.get(
          `${DataBaseAPI.LISTDATA_SERECHCOMPANY}/${this.userInfo.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
            if (res.data.code === 0) {
              this.departmentList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        } else {
          this.departmentList = [];
        }
      },
      // 公司
      companyChange(val) {
        this.query.paymentApplyDepartmentNos = null;
        this.getDepartment(val.val);
      },
      // 收款单位
      receiveCompanyChange(val) {
        if (val.val && val.val.length > 0) {
          this.query.receiveCompanyNos = val.val.map((item) => {
            return item.partnerCode;
          });
        } else {
          this.query.receiveCompanyNos = [];
        }
      },
      // 付款银行账户
      bankAccountChange(val) {
        if (val.val && val.val.length > 0) {
          this.query.bankAccountNum = val.val[0].bankAccountNum;
          this.query.bankAccountName = val.val[0].bankAccountName;
        } else {
          this.query.bankAccountNum = null;
          this.query.bankAccountName = null;
        }
      },
      // 销售合同号
      salesOrderChange(val) {
        this.query.salesOrderNo = val.val && val.val.length > 0 ? val.val[0].contractNo : null;
      },
      // 采购合同号
      purchaseOrderChange(val) {
        this.query.purchaseOrderNo = val.val && val.val.length > 0 ? val.val[0].contractNo : null;
      },
      //获取数据
      getData() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageSize, pageNum };
        if (XEUtils.isArray(params.supplyChainNo))
          params.supplyChainNo = params.supplyChainNo[0].supplierCode;
        // if(!XEUtils.isEmpty(params.paymentApplyDepartmentNos)) params.paymentApplyDepartmentNos= params.paymentApplyDepartmentNos.join(",")
        this.load = true;
        this.$axios.post(API.LIST_FUND_PAYMENT_BY_PAGE, filterEmpty(params)).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type === 'add') {
          this.handleAdd();
        } else if (type === 'edit') {
          this.handelEdit();
        } else if (type === 'delete') {
          this.handleDel();
        } else if (type === 'export') {
          this.commonExport();
        } else if (type === 'generateCredentials') {
          this.batchGenarateVoucher(
            'AE_AP_PAYMENTS',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSignSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_SIGN_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
      },
      // 列表双击
      dblclickEvent(value) {
        this.toPath('paymentDetails', { id: value.row.id });
      },
      //新增
      handleAdd() {
        this.toPath('paymentApplyList', {});
      },
      // 修改
      handelEdit() {
        if (this.multipleSelection.length != 1) {
          return this.tips('onlyOneSelectData', 'error');
        }
        let item = this.multipleSelection[0];
        if (item.paymentStatus != 'Saved' && item.paymentStatus != 'Error') {
          return this.tips('noEdit', 'error');
        }
        this.toPath('paymentEdit', { id: item.id });
      },
      // 删除
      handleDel() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (i.paymentStatus == 'Saved' || i.paymentStatus == 'Error') {
            canDelitems.push(i);
          }
        });
        if (canDelitems.length == 0) {
          return this.tips('noCanDelData', 'error');
        }
        let items = canDelitems.map((i) => i.id).join(',');
        let message = '';
        if (canDelitems.length !== this.multipleSelection.length) {
          message = this.$t('paymentList.message.hasCannotDelTip');
        }
        this.$confirmAction(this.$t('confirm.delete'), message)
          .then(() => {
            this.del(items);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除
      del(ids) {
        this.loading.startLoading();
        this.$axios.post(API.PAYMENT_DELETE, qs.stringify({ ids })).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 批量生成凭证
      generateCredentials() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        this.dialogVisible = true;
      },
      closeDialog() {
        this.dialogVisible = false;
        this.postDate = null;
      },
      selectDate() {
        const fundPayableInvoiceCredentialDTO = this.multipleSelection.map((i) => {
          return {
            id: i.id,
            version: i.version,
            postDate: this.postDate,
          };
        });
        this.loading.startLoading();
        this.$axios.post(API.GENERATE_CREDENTIALS, fundPayableInvoiceCredentialDTO).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.closeDialog();
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`paymentList.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/payment/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
